<template>
  <g :id="data.id" class="transform" :transform="matrix">
    <g class="anchor" @mousedown.stop="handleClick">
      <template>
        <comp-text
          v-if="
            data.type === 'text' ||
              data.type === 'title' ||
              data.type === 'digest' ||
              data.type === 'advertuser'
          "
          :data="data"
        />
        <comp-image
          v-else-if="
            data.type === 'image' ||
              data.type === 'logo' ||
              data.type === 'icon'
          "
          :data="data"
        />
      </template>
    </g>
  </g>
</template>

<script>
import { isMac } from 'utils/helper';
import keyboardJS from 'keyboardjs';

export default {
  name: 'Comp',
  props: {
    data: {},
    z: Number
  },
  computed: {
    matrix() {
      return `translate(${this.data.x - this.data.width / 2 || 0}, ${this.data
        .y -
        this.data.height / 2 || 0}) rotate(${this.data.rotate || 0}, ${(this
        .data.width || 0) / 2}, ${(this.data.height || 0) / 2})`;
    }
  },
  methods: {
    editorCopy() {
      let _this = this;
      keyboardJS.resume();
      keyboardJS.bind(isMac() ? 'command + c' : 'ctrl + c', null, function() {
        if (_this.$store.state.selected !== null) {
          _this.$store.commit('update', {
            clipboard: _this.$store.state.selected
          });
        }
      });
    },
    handleClick(e) {
      this.$store.dispatch('elm_click', {
        id: this.data.id,
        event: e
      });
      this.editorCopy();
    }
  }
};
</script>

<style scoped></style>
